import { AsyncValidationError } from '@dxp-module/common'
import { IntlShape } from 'react-intl'
import { SignupFormSchema, SignupFormData } from '../model/SignupForm'

const signupFormDataTransformer = {
  to(data: SignupFormData): SignupFormSchema {
    const formData: SignupFormSchema = {
      nameInfo: {
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        salutation: data.salutation || 1,
        phone: data?.phone ?? '',
        uniqueUserEmail: data.uniqueUserEmail || '',
        password: data.password || '',
        confirmPassword: data.confirmPassword || '',
        identificationNumberRut: data.identificationNumberRut || '',
      },
      phoneNumberByArea: {
        areaCode: data?.areaCode ?? '',
        phone: data?.phone ?? '',
      },
      termsAndConditions: data.termsAndConditions ?? false,
    }

    return formData
  },

  fromOld(
    errors: { [errorName: string]: string },
    intl?: IntlShape
  ): AsyncValidationError {
    const validationErrors = {}

    for (const path in errors) {
      let errorMessage = errors[path] ?? ''
      const pathArray = path.includes('.') ? path.split('.') : [path]
      const lastNestedField = pathArray[pathArray.length - 1]

      if (intl?.messages?.[errorMessage]) {
        errorMessage = intl.formatMessage({ id: errorMessage })
      }
      if (!path || !errorMessage) {
        throw new Error('The validation error is not formatted correctly!')
      }

      pathArray.reduce(
        (
          field: { [errorName: string]: { [errorName: string]: string[] } },
          nestedField: string
        ) =>
          (field[nestedField] =
            nestedField === lastNestedField
              ? { __errors: [errorMessage] }
              : {}),
        validationErrors
      )
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (validationErrors as any)?.registerForm ?? validationErrors
  },

  from(data: SignupFormSchema): SignupFormData {
    const formData: SignupFormData = {
      firstName: data.nameInfo?.firstName,
      lastName: data.nameInfo?.lastName,
      password: data.nameInfo?.password,
      confirmPassword: data.nameInfo?.confirmPassword,
      salutation: data.nameInfo?.salutation,
      phone: data.phoneNumberByArea?.phone ?? '',
      uniqueUserEmail: data.nameInfo?.uniqueUserEmail,
      identificationNumberRut: data?.nameInfo?.identificationNumberRut ?? '',
      areaCode: data.phoneNumberByArea?.areaCode ?? '',
      termsAndConditions: data?.termsAndConditions,
    }

    if (data.nameInfo?.firstName) {
      formData.firstName = data.nameInfo.firstName
    }

    if (data.nameInfo?.lastName) {
      formData.lastName = data.nameInfo.lastName
    }

    if (data.nameInfo?.password) {
      formData.password = data.nameInfo.password
    }

    if (data.nameInfo?.salutation) {
      formData.salutation = data.nameInfo.salutation
    }

    if (data.phoneNumberByArea?.phone) {
      formData.phone = data.phoneNumberByArea.phone
    }

    if (data.nameInfo?.uniqueUserEmail) {
      formData.uniqueUserEmail = data.nameInfo.uniqueUserEmail
    }

    if (data.phoneNumberByArea?.areaCode) {
      formData.areaCode = data.phoneNumberByArea.areaCode
    }

    if (data.contactInfo?.phone) {
      formData.phone = data.contactInfo.phone
    }

    if (data.nameInfo?.phone) {
      formData.phone = data.nameInfo.phone
    }

    if (data.nameInfo?.identificationNumberRut) {
      formData.identificationNumberRut = data.nameInfo.identificationNumberRut
    }

    return formData
  },
}

export default signupFormDataTransformer
